// Polyfills for older browsers - must be first
import "react-app-polyfill/stable";
import "core-js/stable";

import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import { createRoot } from "react-dom/client";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import "./browser-normalize.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

const container = document.getElementById("root");
const root = createRoot(container);

msalInstance
  .initialize()
  .then(() => {
    msalInstance.handleRedirectPromise().catch(() => {
      // Silently handle redirect errors
    });

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  })
  .catch(() => {
    // MSAL failed to initialize — render app without SSO support
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });

reportWebVitals();
